import { useMutation, useQueryClient } from '@tanstack/react-query';
import { JudgeWriteRequest } from '~/apis/ssf';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateRefereeMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.judgesCreate,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function useUpdateRefereeMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: JudgeWriteRequest }) => SSF.api.judgesUpdate(id, payload),
    onSuccess: ({ data: response }) => {
      client.invalidateQueries({ queryKey: keys.lists() });
      client.invalidateQueries({ queryKey: keys.detail(response.id) });
    },
  });
}

export function useDeleteRefereeMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.judgesDestroy,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
